import { render } from "./FAQsContent.vue?vue&type=template&id=b578d5bc&scoped=true&ts=true"
import script from "./FAQsContent.vue?vue&type=script&lang=ts"
export * from "./FAQsContent.vue?vue&type=script&lang=ts"

import "./FAQsContent.vue?vue&type=style&index=0&id=b578d5bc&scoped=true&lang=css"

import exportComponent from "/tmp/build/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b578d5bc"]])

export default __exports__